export default "__VITE_ASSET__Cbaf30i5__"